export default [
    {
        path: "/training/career-plan",
        component: () => import("../Components/List.vue"),
        name: "training-career-plan-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/career-plan/create",
        component: () => import("../Components/Create.vue"),
        name: "training-career-plan-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/career-plan/detail-list",
        component: () => import("../Components/DetailList.vue"),
        name: "training-career-plan-detail-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/career-plan/detail",
        component: () => import("../Components/DetailCreate.vue"),
        name: "training-career-plan-detail",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/career-plan/detail-edit/:id",
        component: () => import("../Components/DetailEdit.vue"),
        name: "training-career-plan-detail-edit",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/career-plan/result",
        component: () => import("../Components/Result.vue"),
        name: "training-career-plan-result",
        meta: {
            requiresAuth: true,
        },
    },
];
